export const ON_THE_FLY_MODULE_ID = "cmg9u6a4200006ocwui4sh3qd";
export const PLAY_MODULE_ID = "cm1ub45r80000vhsa89dnikud";
export const DISCOVERY_MODULE_ID = "clswpxzsl0001a4gpwdko3fys";
export const OBJECTION_MODULE_ID = "clswpxzsl0000a4gpo97jqf1z";
export const PITCH_MODULE_ID = "clswpxzsm0003a4gpe0q9z4ma";
export const COLD_CALL_MODULE_ID = "clzvi5r3y0000o61swmun4rbw";

export const ON_THE_FLY_SCENARIO_TYPE_CONFIG = {
  DISCOVERY: {
    label: "Discovery",
    moduleIds: [DISCOVERY_MODULE_ID],
  },
  OBJECTION: {
    label: "Objection Handling",
    moduleIds: [OBJECTION_MODULE_ID],
  },
  PITCH: {
    label: "Pitch / Messaging",
    moduleIds: [PITCH_MODULE_ID],
  },
  COLD_CALL: {
    label: "Cold Call",
    moduleIds: [COLD_CALL_MODULE_ID],
  },
  OTHER: {
    label: "Uncategorized",
    moduleIds: [
      PLAY_MODULE_ID,
      DISCOVERY_MODULE_ID,
      OBJECTION_MODULE_ID,
      PITCH_MODULE_ID,
      COLD_CALL_MODULE_ID,
    ],
  },
};

export const ON_THE_FLY_SCENARIO_TYPES = Object.keys(
  ON_THE_FLY_SCENARIO_TYPE_CONFIG
);

export const ON_THE_FLY_PRACTICE_SCENARIO_TYPES =
  ON_THE_FLY_SCENARIO_TYPES.filter((type) => type !== "OTHER");

export const ON_THE_FLY_SCENARIO_TYPE_LABELS = Object.fromEntries(
  Object.entries(ON_THE_FLY_SCENARIO_TYPE_CONFIG).map(([type, config]) => [
    type,
    config.label,
  ])
);
